
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
// import { useReactToPrint } from "react-to-print";
import { ArrowLeft, Download, FileDown, Mail, MoveLeft, Play, Printer, PrinterCheck, Search, Settings } from 'lucide-react';
import classes from "./DeductionReport.module.css"
import RotatingLogo from '../../Assets/Promix.svg'
import BackLogo from '../../Assets/assets/back.svg'
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";
import api, { BASE_URL } from "../../Components/API/Api";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const DeductionReport = () => {
  const location = useLocation();
  const receiptRef = useRef(null);
  const [savings, setSavings] = useState([]);
const [noData, setNoData] = useState(false);
const [savingsTypeLoading, setSavingsTypeLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [bearer, setBearer] = useState('');
  const [savingsLoading, setSavingsLoading] = useState(false);
  const navigate = useNavigate();
  const [savingsId, setSavingsId] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);
  const [reportRows, setReportRows] = useState([]);
  const [reportMonth, setReportMonth] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('authToken');
     

      if (value !== null) {
        setBearer(value);
      }
    
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


const [summary, setSummary] = useState([]);


 const fetchReports = async () => {
  setSavingsLoading(true);
  try {
    const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
    
    const response = await api.get(`/v1/monthly-deduction-report`, {
      params: {
      company_id: companyId,
      month: selectedProductId,

      },
      headers: {
        'Content-Type': 'application/json'
       
      }
    });

  

    const data = response.data?.data;

    setReportColumns(data?.columns || []);
    setReportRows(data?.rows || []);
    setReportMonth(data || "");
   

    if ((data?.rows || []).length === 0) {
        Swal.fire({
            icon: "error",
            title: "No Data Found",
            text: "No data to be displayed."
        });

        setReportColumns([]);
        setReportRows([]);
        return;
    }
    

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setAccounts([]);   // ✅ also clear here on error
      setNoData(true);
    }
  } finally {
    setSavingsLoading(false);
  }
};

  useEffect(() => {
    const fetchSavingsTypes = async () => {
      setSavingsTypeLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-deducted-months', 
          { 
            // params: { name: 'payment' } 
        }
      );
        if (res.data && Array.isArray(res.data.data)) {
          setSavings(res.data.data);
        } else {
          setSavings([]);
        }
      } catch (err) {
        setSavings([]);
      } finally {
        setSavingsTypeLoading(false);
      }
    };
    fetchSavingsTypes();
  }, []);

  const memberOptions = savings.map((data) => ({
  value: data,
  label: data,
}));


const userData = JSON.parse(localStorage.getItem('userData'));


const tableRef = useRef(null);

const printReport = () => {
  const printContents = receiptRef.current.innerHTML;

  const printWindow = window.open("", "_blank", "width=1200,height=900");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Members' Savings Balance Report</title>

        <style>

          body{
              font-family: Arial, sans-serif;
              margin:20px;
              color:#000;
          }

          h1{
              text-align:center;
              margin-bottom:5px;
          }

          p{
              text-align:center;
              margin-top:0;
              margin-bottom:25px;
          }

          table{
              width:100%;
              border-collapse:collapse;
          }

          th,td{
              border:1px solid #ddd;
              padding:8px;
              font-size:12px;
              text-align:left;
          }

          th{
              background:#f3f4f6;
              color:#000;
              font-weight:bold;
          }

          tr{
              page-break-inside:avoid;
          }

          @page{
              margin:10mm;
          }

        </style>

      </head>

      <body>

      ${printContents}

      </body>

    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

const exportToExcel = () => {
  if (!reportRows.length) {
    Swal.fire({
      icon: "warning",
      title: "No Data",
      text: "There is no report to export.",
    });
    return;
  }

  // Build excel rows using the dynamic columns
  const excelData = reportRows.map((row) => {
    const obj = {};

    reportColumns.forEach((column) => {
      obj[column.replaceAll("_", " ").toUpperCase()] = row[column];
    });

    return obj;
  });

  // Create workbook
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Monthly Deduction Report"
  );

  // Optional: Auto width
  const columnWidths = reportColumns.map((col) => ({
    wch: Math.max(col.length + 5, 18),
  }));

  worksheet["!cols"] = columnWidths;

  // Write workbook
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(data, `Detailed_Monthly_Deduction_${reportMonth?.month}.xlsx`);
};


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          {/* <MoveLeft className={classes.iconBtn} onClick={() => navigate(-1)} /> */}
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Members' Detailed Monthly Deduction Report</h3>
            
          </div>
          
        </div>
         <div className={classes.Group3} style={{marginTop: '32px'}}>
          <div>
            <label>Month</label>
              <div className={classes.searchableDropdown}>
              <Select
                options={memberOptions}
                value={memberOptions.find(option => option.value === selectedProductId) || null}
                onChange={(selected) => setSelectedProductId(selected?.value || "")}
                placeholder="Select Month..."
                isLoading={savingsTypeLoading}
                isSearchable
                  styles={{
                  control: (provided) => ({

                    ...provided,

                    minHeight: "35px",

                    height: "35px",

                    borderRadius: "6px",

                    borderColor: "#d1d5db",

                    fontSize: 13,

                    // zIndex: 99999,

                    boxShadow: "none",

                    "&:hover": {

                      borderColor: "#6b7280",

                    },

                  }),

                  valueContainer: (provided) => ({

                    ...provided,

                    height: "35px",

                    padding: "0 8px",

                  }),

                  input: (provided) => ({

                    ...provided,

                    margin: 0,

                    padding: 0,

                    fontSize: 13

                  }),

                  indicatorsContainer: (provided) => ({

                    ...provided,

                    height: "35px",

                  }),

                  clearIndicator: (provided) => ({

                    ...provided,

                    padding: "4px",

                  }),

                  dropdownIndicator: (provided) => ({

                    ...provided,

                    padding: "4px",

                  }),

                  menu: (provided) => ({

                    ...provided,

                    zIndex: 99999,

                    fontSize: 13

                  }),

                }}
              />
        {/* <select
  value={selectedProductId}
  onChange={(e) => {
    const productId = Number(e.target.value);

    const selectedItem = savings.find(
      (item) => item.id === productId
    );

    if (!selectedItem) return;

    setSelectedProductId(productId);
    setSelectedCompanyId(selectedItem.company_id);
    setSavingsId(selectedItem.id);

    setSelectedProducts((prev) => {
      const exists = prev.some(
        (product) => product.id === selectedItem.id
      );

      if (exists) return prev;

      return [...prev, selectedItem];
    });
  }}
>
  <option value="">Select Month</option>

  {savingsTypeLoading ? (
    <option disabled>Loading months...</option>
  ) : (
    savings.map((product) => (
      <option
        key={product.data}
        value={product.data}
      >
        {product.data}
      </option>
    ))
  )}
</select> */}

                
          </div>
          </div>
         
          <button disabled={!selectedProductId || savingsTypeLoading} className={classes.loanBtn} onClick={fetchReports}> <Play size={14} color="#fff"/> Run Report </button>
         
          </div>
      
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         
         {reportColumns.length === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : (
             <>
               <div className={classes.sideTools}>
                 {reportColumns.length > 0 && (
                   <div className={classes.filterIcons}>
                     <Mail
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <PrinterCheck 
                      onClick={printReport}
                      //  onClick={() => window.print()}
                       className={classes.iconBtns}
                     />
                    <FileDown 
                       className={classes.iconBtns}
                        onClick={exportToExcel}
                     />
                   </div>
                 )}
               </div>
             <div ref={receiptRef} style={{
    // padding: "40px",
    background: "#ffffff",
  }}>
          <div className={classes.cntrTable} >
            <h1 className={classes.cntrTxt}>{userData?.company?.name}</h1>
              <p className={classes.cntrTx122} style={{marginBottom: "40px"}} >
                Members' Detailed Monthly Deduction Report - {reportMonth?.month}
              </p>
           

          </div>
 <table style={{ width: "100%", borderCollapse: "collapse", margin: 'auto' }}>
        <thead>
            <tr>
                <th
                    style={{
                        textAlign: "center",
                        fontSize: 12,
                        borderBottom: "1px solid #d1d5db"
                    }}
                >
                    S/N
                </th>

                {reportColumns.map((column, index) => (
                    <th
                        key={index}
                        style={{
                            textAlign:
                                column === "member_name" ||
                                column === "member_number"
                                    ? "left"
                                    : "right",
                            fontSize: 12,
                            padding: 5,
                            borderBottom: "1px solid #d1d5db"
                            // whiteSpace: "nowrap"
                        }}
                    >
                        {column
                            .replaceAll("_", " ")
                            .replace(/\b\w/g, c => c.toUpperCase())}
                    </th>
                ))}
            </tr>
        </thead>
        <tbody>
            {reportRows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                    <td
                        style={{
                            padding: 5,
                            fontSize: 13,
                            textAlign: "center"
                        }}
                    >
                        {rowIndex + 1}
                    </td>

                    {reportColumns.map((column, colIndex) => (
                        <td
                            key={colIndex}
                            style={{
                                padding: 5,
                                fontSize: 13,
                                borderBottom: "1px solid #d1d5db",
                                textAlign:
                                    column === "member_name" ||
                                    column === "member_number"
                                        ? "left"
                                        : "right"
                            }}
                        >
                            {typeof row[column] === "number"
                                ? row[column].toLocaleString("en-NG", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                  })
                                : row[column] ?? ""}
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>


        </table>
        <div
  // style={{
  //   marginTop: 25,
  //   width: "40%",
  //   marginLeft: "auto",
  //   border: "1px solid #d1d5db",
  //   borderRadius: 6,
  //   overflow: "hidden",
  // }}
  className={classes.summaryContainer}
>
  <div
    style={{
      background: "#f5f5f5",
      padding: "10px 15px",
      fontWeight: "bold",
      fontSize: 14,
      borderBottom: "1px solid #d1d5db",
    }}
  >
    Summary:-
  </div>

  <div style={{ padding: 15 }}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        fontSize: 13,
      }}
    >
      <span>Total Savings Deduction</span>
      <strong>
        {Number(reportMonth?.total_savings || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        fontSize: 13,
      }}
    >
      <span>Total Loan Deduction</span>
      <strong>
        {Number(reportMonth?.total_loans || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: 13,
        fontWeight: "bold",
        borderTop: "1px solid #d1d5db",
        paddingTop: 10,
      }}
    >
      <span>Total Deductions</span>
      <strong>
        {Number(reportMonth?.total_deductions || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>
  </div>
</div>
         </div>

         


 </>
  )}
 
        </div>
     <div style={{ marginTop: 27 }} />
 
      </div>
      {savingsLoading && (
                  <div className={classes.overlay}>
                    <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
                  </div>
                )}

    </div>
  )
}

export default DeductionReport;